<template>
  <v-container id="home" fluid>

    <v-row class="main-banner" justify="center">
     
      <v-col md="3" class="left-main-banner">
        
        <div class="pb-6 text-h2 text-left">Your Idea<br>Built In<br>30 Days</div>
        <div class="pb-10 text-body-1 text-left">We will build your MVP software idea, mobile application, web application, backend API, deployed in Cloud using rapid development methodology.</div>
        <div class="d-flex justify-start"><v-btn class="primary" rounded>Get Started</v-btn></div>
        
      </v-col>

      <v-col md="5" class="right-main-banner">
        
          <v-img src="../assets/30daymvp-idea.jpg" class="fill-height" contain></v-img>
        
      </v-col>

    </v-row>

    <v-row class="our-stack" justify="center">

      <v-col md="8">
        <div class="pt-6 pb-3 text-h4 text-left">Our Stack</div>
        <div class="pb-3 text-body-1 text-left">We use the latest technology to build and deploy your idea within an auto-scaled next-gen cloud infrastructure.</div>
      

        <v-row justify="center">
          <v-col md="3">
            
            <v-card>
              <a href="https://aws.amazon.com" target="_blank"><v-img src="../assets/logo-aws.jpg" class="fill-width" contain></v-img></a>
              <v-card-text>
                <p class="display-1 text--primary">
                  AWS
                </p>
                <div class="text--primary">Cloud Infrastructure</div>
              </v-card-text>
    
            </v-card>
            
          </v-col>

          <v-col md="3">
            
            <v-card>
              <a href="https://www.serverless.com" target="_blank"><v-img src="../assets/logo-serverless.png" class="fill-width" contain></v-img></a>

              <v-card-text>        
                <p class="display-1 text--primary">
                  Serverless
                </p>
                <div>Architecture</div>
              
              </v-card-text>
    
            </v-card>
            
          </v-col>

          <v-col md="3">
            
              <v-card>
                <a href="https://reactjs.org" target="_blank"><v-img src="../assets/logo-react.png" class="fill-width" contain></v-img></a>
                <v-card-text>
                  <p class="display-1 text--primary">
                    React
                  </p>
                <div>Web App Framework</div>
                </v-card-text>
    
              </v-card>
        
          </v-col>

          <v-col md="3">
            
              <v-card>
                <a href="https://reactnative.dev" target="_blank"><v-img src="../assets/logo-react-native.png" class="fill-width" contain></v-img></a>
                <v-card-text>        
                  <p class="display-1 text--primary">
                    React Native
                  </p>
                  <div>Mobile App Framework</div>
                  
                </v-card-text>

              </v-card>
          
          </v-col>
        </v-row>
      </v-col>


    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
  
  }
}
</script>

<style lang="scss">
.main-banner {
  background-color: #fafafa;
}

.our-stack {
  margin-top: 20px;
  background-color: #fbfbfb;
}
</style>
